// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent_name_text {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.agent_text {
  color: black;
  top: 7px;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.name_feild {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  float: left;
  font-size: 12px !important;
  height: 30px !important;
  padding-left: 5px;
}
.name_feild input::placeholder {
  font-size: 12px !important;
}

.name_feild::placeholder {
  font-size: 12px !important;
}

::ng-deep.prodagentmodaladd .modal-dialog {
  max-width: 40% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 7% !important;
}

::ng-deep.prodagentmodaladd {
  top: 0% !important;
  width: 95vw !important;
  left: 4.5% !important;
  margin-top: 7% !important;
  height: 83vh !important;
}
::ng-deep.prodagentmodaladd .modal-dialog {
  max-width: 40% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 1% !important;
}

.addconfigbtn {
  background-color: #17a0b4 !important;
  font-size: 12px !important;
  color: white;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/productagent/productagent.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EAEA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AADJ;;AAGE;EACE,YAAA;EACE,QAAA;AAAN;;AAEE;EACE,8BAAA;AACJ;;AACE;EACE,8BAAA;AAEJ;;AAAE;EACE,oDAAA;EACA,WAAA;EACA,0BCtBO;EDyBL,uBCtBO;EDuBP,iBAAA;AACN;AAAM;EACE,0BC5BG;AD8BX;;AACE;EACE,0BChCO;ADkCX;;AAAE;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AAGJ;;AADE;EACE,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAIJ;AAHI;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AAKN;;AADE;EACE,oCC5DQ;ED6DR,0BC5DO;ED6DP,YAAA;EACA,uBC5DQ;ED6DR,iBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;AAIJ","sourcesContent":["@import \"../../variables.scss\";\r\n.agent_name_text{\r\n    font-size: 12px;\r\n    // font-weight: 600;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 90% !important;\r\n    display: inline-block;\r\n  }\r\n  .agent_text{\r\n    color: black;\r\n      top: 7px;\r\n  }\r\n  .active_card {\r\n    border-left: 4px solid #07a36e;\r\n  }\r\n  .failed_card {\r\n    border-left: 4px solid #da606c;\r\n  }\r\n  .name_feild{\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    float: left;\r\n    font-size: $fontsize;\r\n      // width: 85%;\r\n      // margin-left: 3%;\r\n      height: $inputHeight;\r\n      padding-left: 5px;\r\n      input::placeholder {\r\n        font-size: $fontsize;\r\n          }\r\n  }\r\n  .name_feild::placeholder{\r\n    font-size: $fontsize;\r\n  }\r\n  ::ng-deep.prodagentmodaladd .modal-dialog {\r\n    max-width: 40%!important;\r\n    max-height: 60%!important;\r\n    height: 60%!important;\r\n    margin: auto!important;\r\n    padding: 0 !important;\r\n    top:7%!important;\r\n  }\r\n  ::ng-deep.prodagentmodaladd {\r\n    top: 0%!important;\r\n    width: 95vw !important;\r\n    left: 4.5% !important;\r\n    margin-top: 7% !important;\r\n    height: 83vh !important;\r\n    .modal-dialog {\r\n      max-width: 40%!important;\r\n      max-height: 60%!important;\r\n      height: 60%!important;\r\n      margin: auto!important;\r\n      padding: 0 !important;\r\n      top:1%!important;\r\n    }\r\n  }\r\n\r\n  .addconfigbtn{\r\n    background-color:$btn-color;\r\n    font-size: $fontsize;\r\n    color:white ;\r\n    height: $btnHeight;\r\n    line-height: 20px;\r\n    right: 1%;\r\n    top: 0%;\r\n    cursor: pointer;\r\n  }","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
